export default "__VITE_ASSET__Cf5BZfc4__"